import { FC } from 'react';
import { useTranslation } from 'src/components/dashboard/initialPopups/i18n';
import ErrorDialog from 'src/components/dialogs/ErrorDialog';

const NoBrowserSupport: FC = () => {
  const { t } = useTranslation();

  return (
    <ErrorDialog
      sx={{ zIndex: 2001 }}
      open
      message={t('ERROR_BROWSER_SUPPORT')}
    />
  );
};

export default NoBrowserSupport;
